import ApiReview from "@/common/api.service";
import {
  FETCH_REVIEW_REPORTS,
  FETCH_REVIEW_REPORT,
  UPDATE_REVIEW_REPORT,
  CREATE_REVIEW_REPORT,
  RESET_REVIEW_REPORT,
  DELETE_REVIEW_REPORT
} from "./actions.type";
import {
  FETCH_REVIEW_REPORT_START,
  SET_REVIEW_REPORTS,
  SET_REVIEW_REPORT
} from "./mutations.type";
import i18n from "@/common/lang.serivce";
import _ from "lodash";

const state = {
  reviewReports: [],
  reviewReportsCount: 1,
  reviewReport: {
    worklog: {
      own_work: {},
      continuation_of_work: {},
      continuation_of_work2: {},
      user_work: {},
      supplier_work: {}
    }
  },
  isLoading: false
};

const getters = {
  reviewReportsCount: state => state.reviewReportsCount,
  reviewReports: state => state.reviewReports,
  reviewReport: state => state.reviewReport,
  reviewReportIsLoading: state => state.isLoading,
  reviewReportWorklogTableView: function(state) {
    if (!state.reviewReport) {
      return [];
    }

    let rows = [
      "own_work",
      "continuation_of_work",
      "continuation_of_work2",
      "user_work",
      "supplier_work"
    ];

    return rows.map(rowName => {
      return {
        rowName: rowName,
        name: i18n.t("worklog." + _.camelCase(rowName)),
        workStart: state.reviewReport.worklog[rowName].work_start,
        workFinish: state.reviewReport.worklog[rowName].work_finish,
        madeReviewP1: state.reviewReport.worklog[rowName].made_review_p1,
        vehicleTakenByOccupant:
          state.reviewReport.worklog[rowName].vehicle_taken_by_occupant
      };
    });
  }
};

const actions = {
  [FETCH_REVIEW_REPORTS]({ commit }, [filteringCriteria, search, filters]) {
    commit(FETCH_REVIEW_REPORT_START);
    return ApiReview.filteredCollection(
      "review-reports",
      filteringCriteria,
      search,
      filters
    ).then(({ data }) => {
      commit(SET_REVIEW_REPORTS, data);
    });
  },
  [FETCH_REVIEW_REPORT](context, id) {
    return ApiReview.get("review-reports", id).then(({ data }) => {
      context.commit(SET_REVIEW_REPORT, data);
    });
  },
  [UPDATE_REVIEW_REPORT](context, payload) {
    return ApiReview.put(`review-reports/${payload.id}`, payload);
  },
  [CREATE_REVIEW_REPORT](context, payload) {
    return ApiReview.post("review-reports", payload);
  },
  [RESET_REVIEW_REPORT](context) {
    context.commit(SET_REVIEW_REPORT, {
      worklog: {
        own_work: {},
        continuation_of_work: {},
        continuation_of_work2: {},
        user_work: {},
        supplier_work: {}
      }
    });
  },
  [DELETE_REVIEW_REPORT](context, id) {
    return ApiReview.delete("review-reports", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_REVIEW_REPORT_START](state) {
    state.isLoading = true;
  },
  [SET_REVIEW_REPORTS](state, data) {
    state.reviewReports = data.items || [];
    state.reviewReportsCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_REVIEW_REPORT](state, data) {
    state.reviewReport = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
